import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';

const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            marginTop: theme.spacing(2),
        },
        '& ul': {
            justifyContent: 'center',
        },
        '& .MuiPaginationItem-page.Mui-selected': {
            backgroundColor: '#4D5DCC',
            borderColor: '#4D5DCC',
            color: '#fff'
        },
    },
}));

const PaginationRounded = props => {
    const classes = useStyles();
    const handleChange = (event, value) => {
        props.onChangePage(event, value);
    };

    return ((props.total || 0) < 1) ? (<></>) : (
        <div className={classes.root}>
            <Pagination count={props.total || 0} onChange={handleChange} variant="outlined" shape="rounded" />
        </div>
    );
}

export default PaginationRounded;